export enum Factions {
  ALLIANCE = 0,
  HORDE,
  NEUTRAL,
}
